<template>
<div>
   <div v-if="list.length>0">
     <div class="listlishenr" v-for="(item,index) in list" :key="index">
       <div class="listitem">
         <div class="labesune">
           <span v-if="item.type===0">用户投诉</span>
           <span v-if="item.type===1">功能异常</span>
           <span v-if="item.type===2">體驗問題</span>
           <span v-if="item.type===3">建議意見</span>
           <span v-if="item.type===4">其他</span>
         </div>
         <div class="suennr">
           <span>{{item.content}}</span>
         </div>
         <div class="imgliste" v-if="item.imgs">
           <div class="imgcoagwne" v-for="(imgse,inex) in item.imgs" :key="inex">
             <img :src="imgse.url" alt="">
           </div>
         </div>
         <div class="lainsiwne">
           <span>联系方式：{{item.phone}}</span>
           <span>{{item.createTime| dateformat('YYYY-MM-DD HH:mm')}}</span>
         </div>
         <div class="ragtwbj" v-if="item.status">
           <div class="lainsiwne">
             <span style="color: orangered;font-size: 0.32rem">平台回复</span>
             <span style="color: #444444;font-weight: 500">{{item.replyTime| timeFilters}}</span>
           </div>
           <div class="retsubcoanner">
             <span>{{item.replyMessage}}</span>
           </div>
         </div>
       </div>
     </div>
   </div>
  <div v-if="list.length<1">
    <span style="font-size: 0.34rem">暂无数据</span>
  </div>
</div>
</template>

<script>
import {getUrlKey} from "@/until/getUrlcode";
import {Toast} from "mand-mobile";
import wx from "weixin-js-sdk";

export default {
  name: "fankuilist",
  data(){
    return{
     list:[]
    }
  },
  // 过滤器
  filters: {
    timeFilters(data) { //data是接受的item.time
      //将字符串转换成时间格式
      let result;
      let timePublish = new Date(data);
      let timeNow = new Date();
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let month = day * 30;
      let year = month * 12;
      let diffValue = timeNow - timePublish;
      let diffMonth = diffValue / month;
      let diffWeek = diffValue / (7 * day);
      let diffDay = diffValue / day;
      let diffHour = diffValue / hour;
      let diffMinute = diffValue / minute;
      let diffYear = diffValue / year;
      if (diffValue < minute) {
        result = "刚刚回复";
      } else if (diffYear > 1) {
        result = parseInt(diffYear) + "年前";
      } else if (diffMonth > 1) {
        result = parseInt(diffMonth) + "月前";
      } else if (diffWeek > 1) {
        result = parseInt(diffWeek) + "周前";
      } else if (diffDay > 1) {
        result = parseInt(diffDay) + "天前";
      } else if (diffHour > 1) {
        result = parseInt(diffHour) + "小时前";
      } else if (diffMinute > 1) {
        result = parseInt(diffMinute) + "分钟前";
      } else {
        result = "刚刚回复";
      }
      return result;

    },
  },
  activated() {
    if (getUrlKey("cnm", window.location.href)) {
      Toast.loading('加载中...');
      // debugger
      localStorage.setItem('mupressMobiltoken', getUrlKey("cnm", window.location.href));
      var that = this;
      setTimeout(function () {
        that.getsywbe(getUrlKey("shopkey", window.location.href));
      }, 20)
    } else if(localStorage.getItem('mupressMobiltoken')){
      Toast.loading('加载中...');
      this.getSignTaskList();
    }else if(localStorage.getItem('headerParams')){
      localStorage.setItem('mupressMobiltoken',JSON.parse(localStorage.getItem('headerParams')).Authorization);
      Toast.loading('加载中...');
      var that = this;
      setTimeout(function () {
        that.getsywbe(JSON.parse(localStorage.getItem('headerParams')).shopkey);
      }, 20)
    }else {
      Toast.loading('加载中...');
      if (getUrlKey("from", window.location.href) && getUrlKey("from", window.location.href) == 'app') {
        HookUp.postMessage(JSON.stringify({
          code: 401
        }));
      } else {
        wx.miniProgram.navigateBack({})
        wx.miniProgram.navigateTo({url: '/pages/login/login'})
      }
    }
  },
  methods:{
    getsywbe(appCode){
      const par={
        appCode:(appCode&&appCode!=undefined)?appCode:'1572677768'
      }
      this.http
        .APIASK(this.ports.getStoreInfo, 'get', par)
        .then((res) => {
          localStorage.setItem('shopkey', JSON.stringify(res));
          this.getSignTaskList()
        })
    },
    getSignTaskList(){
      this.http.APIASK(this.ports.getUserFeed, 'get',).then(res => {
        this.list=res
        // debugger
      console.log(res)
        Toast.hide()
      }).catch(err => {
        Toast.hide()
      })

    }
  }
}
</script>

<style lang="less">
.listlishenr{
 width: 100%;
  background-color: white;
 margin-bottom: 0.1rem;
  padding-bottom: 0.3rem;
  .listitem{
    width: 94%;
    margin-left: 3%;
   padding-top: 0.2rem;
    .labesune{

      font-size: 0.28rem;
      color: #2a78dc;
      width: 1.4rem;
      height: 0.5rem;
      border: 1px solid #2a78dc;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .suennr{
      font-size: 0.34rem;
      color: #333333;
      width: 100%;
      display: flex;
      justify-content: flex-start !important;
      margin-top: 0.2rem;
      flex-wrap:wrap !important;
      text-align: left;
      line-height: 0.5rem;
      word-break:break-word;

    }
    .imgliste{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 0.2rem;
    }
    .imgcoagwne{
      width:2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.2rem;
      img{
        width:2rem;
        height: 2rem;
      }
    }
    .lainsiwne{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.25rem;
      color: #666666;
      margin-top: 0.3rem;
    }
     .ragtwbj{
       width: 100%;
       margin-top: 0.4rem;
    }
    .retsubcoanner{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      text-align: left;
      line-height: 0.4rem;
      background-color: rgb(240,241,246);
      font-size: 0.28rem;
      color: #333333;
      font-weight: 500;
      border-radius: 0.1rem;
      margin-top: 0.2rem;
      word-break: break-word;
      span{
        margin: 0.1rem 0.2rem;
      }
    }

  }

}
</style>
